export const commonI18n = {
  "error.500": "Wystąpił błąd serwera",
  "error.404": "Nie znaleziono strony",
  "error.home": "Przejdź do strony głównej",
  "error.unlogged": "Niezalogowany",
  "error.undefined": "Nieznany błąd",

  back: "Wróć",

  "report_error.title": "Zgłoś błąd",
  "contact_page.send": "Wyślij",
  "report_error.send_success": "Dziękujemy za zgłoszenie błędu",

  "address.invoice": "Czy chcesz kupić na firmę?",
  "address.nip": "NIP",
  "address.company": "Nazwa firmy",
  "address.firstname": "Imię",
  "address.lastname": "Nazwisko",
  "address.street": "Ulica",
  "address.house": "Nr lokalu",
  "address.flat": "Nr mieszkania",
  "address.city": "Miejscowość",
  "address.zip_code": "Kod pocztowy",
  "address.phone": "Numer telefonu",
  "address.country": "Kraj",

  "cart.summary.title": "Podsumowanie",
  "cart.summary.amount": "Liczba produktów",
  "cart.summary.vat": "Podatek VAT",
  "cart.summary.vat_included": "w tym VAT",
  "cart.summary.discount": "Zniżka",
  "cart.summary.applied_discounts": "Zastosowane rabaty",
  "cart.summary.brutto": "Brutto",

  "form_validation.checkbox.required": "Zaznacz pole",
  "form_validation.required": "Wypełnij pole.",
  "form_validation.dateRange.start": "Początek zakresu jest błędny",
  "form_validation.dateRange.end": "Koniec zakresu jest błędny",
  "form_validation.exact": ({ value }: { value: number }) =>
    `To pole powinno zawierać dokładnie ${value} znaków`,
  "form_validation.min": ({ value }: { value: number }) =>
    `Minimalna długość ${value} znaków`,
  "form_validation.max": ({ value }: { value: number }) =>
    `Maksymalna długość ${value} znaków`,
  "form_validation.invalid_format": "Błędny format",
  "form_validation.phone": "Błędny format numeru telefonu",
  "form_validation.content_block_editor.errors": "Edytor zawiera błędy",
  "form_validation.email.wrong_format": "Błędny format e-maila",
  "form_validation.image.required": "Grafika jest wymagana",
  "form_validation.image.alt.required": "Wymagany opis alt dla grafiki",
  "form_validation.multiselect.required": "Wybierz co najmniej jedną opcję",
  "form_validation.url": "Adres URL musi zaczynać się od http:// lub https://.",
};
